import React, { useEffect, useState } from "react";
import { Button, ProgressBar } from "react-bootstrap";
import donuticon from "../../../assets/images/donuticon.svg";
import viewusericon from "../../../assets/images/viewusericon.svg";
import criticalincidentreportsicon from "../../../assets/images/criticalincidentreportsicon.svg";
import resourceicon from "../../../assets/images/resourceicon.svg";
import filesforreviewicon from "../../../assets/images/filesforreviewicon.svg";
import videoconferencesicon from "../../../assets/images/videoconferencesicon.svg";
import arrowicon from "../../../assets/images/arrowicon.svg";
import annualicon from "../../../assets/images/annualicon.svg";
import monthlyicon from "../../../assets/images/monthlyicon.svg";
import quarterlyicon from "../../../assets/images/quarterlyicon.svg";
import { Link, useParams } from "react-router-dom";
import ConcentricRadialCharts from "../circleradialchart/Circleradialchart";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Recenttasktab from "./recenttasktab/Recenttasktab";
import Singleactivitytab from "../singleactivitytab/Singleactivitytab";
import RecentFileTab from "./RecentFilePageTab/RecentFileTab";
import { useAuth } from "../../../firebase/AuthProvider";
import Modal from "react-bootstrap/Modal";
import "./serviceoverviewtab.css";
import SurveyHistoryTab from "./SurveyHistoryTab/SurveyHistoryTab";
import FeatureUnavailablePopup from "../../ui/FeatureUnavailablePopup/FeatureUnavailablePopup";
import "../participant-snapshot/ParticipantSnapshot.css";
const Serviceoverviewtab: React.FC = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { currentUser } = useAuth();
  const { id: participantId } = useParams();

  const [authToken, setAuthToken] = useState<string>("");
  const [activeTab, setActiveTab] = useState<
    "recentfilestab" | "singleactivitytab" | "recenttasktab" | "surveyhistory"
  >("recenttasktab");

  useEffect(() => {
    let isMounted = true;

    currentUser?.getIdToken().then((token) => {
      if (token) {
        setAuthToken(token);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [participantId]);

  const URLForViewAllOfTab = (): string => {
    switch (activeTab) {
      case "singleactivitytab":
        return `/participant/${participantId}/activity`;
      case "recentfilestab":
        return `/participant/${participantId}/service-overview/recentfiles`;
      case "recenttasktab":
        return `/tasks?participant=${participantId}&viewAll=true`;
      case "surveyhistory":
        return `/surveys/participant/${participantId}`;
      default:
        return "/home";
    }
  };

  return (
    <>
      <div className="common_content_inner mby_t_24">
        <div className="top border_tittle">
          <div className="top_bar_tittle">
            <h2>Goals</h2>
          </div>
        </div>
        <div className="goal_grid mby_20">
          <div className="goal_card_flx">
            <div onClick={handleShow} className="goal_card goal_card_green">
              <div className="goal_card_left">
                <h3>1. Goal Name</h3>
                <p>10 Day Home Visit</p>
              </div>
              <div className="goal_card_right">
                <p>Last Updated (20,May 2025)</p>
              </div>
            </div>
            <div onClick={handleShow} className="goal_card goal_card_purpple">
              <div className="goal_card_left">
                <h3>2. Goal Name</h3>
                <p>10 Day Home Visit</p>
              </div>
              <div className="goal_card_right">
                <p>Last Updated (18,May 2025)</p>
              </div>
            </div>
            <div onClick={handleShow} className="goal_card goal_card_yellow">
              <div className="goal_card_left">
                <h3>3. Goal Name</h3>
                <p>10 Day Home Visit</p>
              </div>
              <div className="goal_card_right">
                <p>Last Updated (16,May 2025)</p>
              </div>
            </div>
          </div>
          <div className="goal_medicaid">
            <div className="common_card">
              <div className="medicaidwaiver_card mby_16">
                <div className="medicaidwaiver_card_left">
                  <div className="medicaidwaiver_card_icon flex-shrink-0">
                    <img src={donuticon} alt="donuticon" />
                  </div>
                  <div className="medicaidwaiver_card_cntnt">
                    <h3>Medicaid Waiver Budget</h3>
                    <p>#16,750 used of $2,000 (67%)</p>
                  </div>
                </div>
                <div className="medicaidwaiver_card_right">
                  <div className="sm_progress_bar">
                    <ProgressBar>
                      <ProgressBar variant="success" now={40} />
                    </ProgressBar>
                  </div>
                  <FeatureUnavailablePopup
                    message="Usage Breakdown coming soon!"
                    position="bottom"
                  >
                    <Link to="/">View Usage Breakdown</Link>
                  </FeatureUnavailablePopup>
                </div>
              </div>
              <div className="files_grid">
                <FeatureUnavailablePopup
                  message="Feature is currently unavailable"
                  className="cursor-pointer"
                >
                  <div className="common_card cir_card">
                    {/* <div className="view_user"><img src={viewusericon} alt="viewusericon" />3</div> */}
                    <div className="common_card_txt">
                      <p>
                        Critical Incident <span>Reports</span>
                      </p>
                      <h2>2</h2>
                    </div>
                    <div className="common_card_icon">
                      <div className="icon_color_bg red">
                        <img
                          src={criticalincidentreportsicon}
                          alt="criticalincidentreportsicon"
                        />
                      </div>
                    </div>
                  </div>
                </FeatureUnavailablePopup>

                <div className="common_card">
                  <div className="common_card_txt">
                    <p>
                      Resource <span>Request</span>
                    </p>
                    <h2>2</h2>
                  </div>
                  <div className="common_card_icon">
                    <div className="icon_color_bg green">
                      <img src={resourceicon} alt="resourceicon" />
                    </div>
                  </div>
                </div>
                <div className="common_card">
                  <div className="common_card_txt">
                    <p>
                      Files For <span>Review</span>
                    </p>
                    <h2>3</h2>
                  </div>
                  <div className="common_card_icon">
                    <div className="icon_color_bg blue">
                      <img src={filesforreviewicon} alt="filesforreviewicon" />
                    </div>
                  </div>
                </div>

                <div className="common_card">
                  <div className="common_card_txt">
                    <p>
                      Video <span>Conferences</span>
                    </p>
                    <h2>10</h2>
                  </div>
                  <div className="common_card_icon">
                    <div className="icon_color_bg yellow">
                      <img
                        src={videoconferencesicon}
                        alt="videoconferencesicon"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="radialcharts_card">
                        <ConcentricRadialCharts />
                    </div> */}
          <div className="goal_btm_grid_right">
            <div className="common_card">
              <div className="top border_tittle">
                <div className="top_bar_tittle">
                  <h2>Upcoming Deadlines</h2>
                </div>
              </div>
              <div className="upcoming_deadlines_flx">
                <div className="upcoming_deadlines_card upcoming_deadlines_card_red">
                  <div className="upcoming_deadlines_card_left">
                    <h3>Monthly </h3>
                    <p>May 20th</p>
                  </div>
                  <div className="upcoming_deadlines_card_right">
                    <div className="upcoming_deadlines_icon">
                      <img src={monthlyicon} alt="monthlyicon" />
                    </div>
                  </div>
                </div>
                <div className="upcoming_deadlines_card upcoming_deadlines_card_green">
                  <div className="upcoming_deadlines_card_left">
                    <h3>Quarterly</h3>
                    <p>May 20th</p>
                  </div>
                  <div className="upcoming_deadlines_card_right">
                    <div className="upcoming_deadlines_icon">
                      <img src={quarterlyicon} alt="quarterlyicon" />
                    </div>
                  </div>
                </div>
                <div className="upcoming_deadlines_card upcoming_deadlines_card_yellow">
                  <div className="upcoming_deadlines_card_left">
                    <h3>Annual</h3>
                    <p>November 7th</p>
                  </div>
                  <div className="upcoming_deadlines_card_right">
                    <div className="upcoming_deadlines_icon">
                      <img src={annualicon} alt="annualicon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="goal_btm_grid participant-snapshot">
          <div className="goal_btm_grid_left">
            <div className="common_card">
              <Tab.Container
                id="left-tabs-example"
                defaultActiveKey="recenttasktab"
              >
                <div className="tab_flx">
                  <Nav variant="pills" className="common_tab">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="recenttasktab"
                        onClick={() => setActiveTab("recenttasktab")}
                      >
                        Recent Task
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="singleactivitytab"
                        onClick={() => setActiveTab("singleactivitytab")}
                      >
                        Activity
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="recentfilestab"
                        onClick={() => setActiveTab("recentfilestab")}
                      >
                        Recent Files
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="surveyhistory"
                        onClick={() => setActiveTab("surveyhistory")}
                      >
                        Survey History
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <div className="view_all">
                    <Link className="arrow_link" to={URLForViewAllOfTab()}>
                      View All <img src={arrowicon} alt="arrowicon" />
                    </Link>
                  </div>
                </div>
                <Tab.Content>
                  {activeTab === "recenttasktab" && (
                    <Tab.Pane eventKey="recenttasktab">
                      <Recenttasktab />
                    </Tab.Pane>
                  )}

                  {activeTab === "singleactivitytab" && (
                    <Tab.Pane eventKey="singleactivitytab">
                      <Singleactivitytab />
                    </Tab.Pane>
                  )}
                  {activeTab === "recentfilestab" && participantId && (
                    <Tab.Pane eventKey="recentfilestab">
                      <RecentFileTab
                        authToken={authToken}
                        participantId={participantId}
                      />
                    </Tab.Pane>
                  )}
                  {activeTab === "surveyhistory" && participantId && (
                    <Tab.Pane eventKey="surveyhistory">
                      <SurveyHistoryTab
                        authToken={authToken}
                        participantId={participantId}
                      />
                    </Tab.Pane>
                  )}
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </div>

      {/* Goal Information popup */}
      <Modal centered show={show} onHide={handleClose} className="custom_popup">
        <Modal.Header closeButton>
          <Modal.Title>Goal Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="stats mby_16">
            <h3>Goal Name</h3>
            <p>
              This year I want to remain living with my grandparents and remain
              in their custody
            </p>
          </div>
          <div className="stats mby_16">
            <h3>Support Strategy</h3>
            <p>
              Natural Supports will follow up with CPS and ensure all steps are
              taken to keep custody and placement intact. B. Support Coordinator
              will follow up and ensure custody remains active. C. Natural
              Supports will maintain household and ensure all utilities are
              provided to sustain me living with them.
            </p>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-lg-0 mb-sm-3 mb-3">
              <div className="stats">
                <h3>Frequency</h3>
                <p>Monthly</p>
              </div>
            </div>
            <div className="col-sm-12 col-lg-6 col-xl-6 mb-lg-0">
              <div className="stats">
                <h3>Review/Accomplish Dates</h3>
                <p>August 5th, January 7th</p>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Serviceoverviewtab;
